import classNames from 'classnames';

interface RibbonLabelProps {
  label: string;
  type: 'golden' | 'biancone' | 'beige';
  className?: string;
  width?: string;
  isUnitPreconstruction?: boolean;
  statusCode?: 'R' | 'CS';
  color?: string;
}

export const RibbonLabel: React.FC<RibbonLabelProps> = ({
  label,
  type,
  width,
  statusCode,
}) => {
  const getWidth = () => {
    if (width) {
      return width;
    }
    if (type === 'golden') {
      const widthMap: Record<string, string> = {
        R: 'min-w-[192px]',
        CS: 'min-w-[176px]',
        default: 'min-w-[160px]',
      };
      return widthMap[statusCode || 'default'] || widthMap['default'];
    }
    return 'min-w-[160px]';
  };

  return (
    <div className={`relative ${getWidth()} w-auto`}>
      <div
        className={classNames(
          'flex items-center justify-center w-auto',
          'p-2',
          'm-2',
          {
            'bg-[#E8D891]': type === 'golden',
            'bg-[#F2D1B4]': type === 'biancone',
            'bg-[#EAE8E5]': type === 'beige',
          }
        )}
        style={{
          clipPath:
            'polygon(100% 0px, 0px 0px, 0px 100%, 100% 100%, calc(100% - 20px) 50%',
          zIndex: -1,
        }}
      >
        <span className="font-sohneBreitHalbfett text-12-18-0.3 md:text-16-26-0.3 whitespace-nowrap z-10 mr-5">
          {label}
        </span>
      </div>
    </div>
  );
};
